import React from "react";
import PropTypes from "prop-types";
import classes from "./Header.module.scss";
import huronLogo from '@global-products/styles/images/huron-logo.svg';
import MILogo from "../../assets/img/Market_Insights_Logo.svg";
import { Link, useHistory, useRouteMatch  } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    type="button"
    className="dropdown-toggle btn"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
));

/**
 * Pure component that displays the Header component
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
const HeaderView = ({
  userName,
  signOut,
  availableRoles
}) => {
  const history = useHistory();
  const isOpenQueryRoute = useRouteMatch("/openquery/*");
  const showBrand = (availableRoles?.includes('GlobalAdmin') || availableRoles?.includes('BrandAdmin')) ?? false;
  const showAccount = availableRoles?.includes('Admin') ?? false;
  const getInitial = (userName) => {
    return userName?.charAt(0)?.toUpperCase() || 'U'; // "U" to match "unnamed" if no userName
  }


  return (
    <div className={`${classes["header"]}`}>
      <div className={classes["logo-wrap"]}>
        <Link to="/" title="Navigate to Home">
          <div className={`${classes["logos"]}`}>
            <img
              src={huronLogo}
              alt="Huron Logo"
              className={`${classes["huron-logo"]}`}
            />
            <div className={`${classes["logo-separator"]}`} />
            {
              !isOpenQueryRoute && <img
                src={MILogo}
                alt="Market Insights Logo"
                className={`${classes["mi-logo"]}`}
              />
            }
          </div>
        </Link>
        <Link to="/openquery" title="Navigate to Query dashboard">
          {isOpenQueryRoute && <span className={classes["application-logo"]}>QUERY</span>}
        </Link>
      </div>
      <div className={`float-right ${classes["header-elements"]}`}>
        <Link to='/help' title="Help">
          <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 640 640" aria-label="Help Icon">
            <path className={`${classes["help-icon"]}`} d="M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM320 240C302.3 240 288 254.3 288 272C288 285.3 277.3 296 264 296C250.7 296 240 285.3 240 272C240 227.8 275.8 192 320 192C364.2 192 400 227.8 400 272C400 319.2 364 339.2 344 346.5L344 350.3C344 363.6 333.3 374.3 320 374.3C306.7 374.3 296 363.6 296 350.3L296 342.2C296 321.7 310.8 307 326.1 302C332.5 299.9 339.3 296.5 344.3 291.7C348.6 287.5 352 281.7 352 272.1C352 254.4 337.7 240.1 320 240.1zM288 432C288 414.3 302.3 400 320 400C337.7 400 352 414.3 352 432C352 449.7 337.7 464 320 464C302.3 464 288 449.7 288 432z" />
          </svg>
        </Link>
        <span>
          <Dropdown title="User Dropdown Menu">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <span className={`${classes["user-profile"]}`}>{getInitial(userName)}</span>
              <strong className={`${classes["user-name"]}`}>{userName || 'unnamed'}</strong>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {showBrand && (
                <Dropdown.Item onClick={() => history.push('/UserBrands')}>
                  Brand
                </Dropdown.Item>
              )}
              {showAccount && (
                <Dropdown.Item onClick={() => history.push('/UserAccounts')}>
                  Account
                </Dropdown.Item>
              )}
              <Dropdown.Item onClick={() => history.push('/User')}>
                My User
              </Dropdown.Item>
              <Dropdown.Item className={`${classes["sign-out"]}`} onClick={signOut}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      </div>
    </div>
  );
};

HeaderView.propTypes = {
  userName: PropTypes.string.isRequired,
  signOut: PropTypes.func.isRequired,
  availableRoles: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default HeaderView;
